import React from 'react'
import DOMPurify from 'dompurify'
// @ts-ignore
import classnames from 'classnames'
import { RTECompoundProps } from './RTECompound.types'
import { addBaseDomain } from '../../../../utils/common-utils'

export const RTECompound = (props: RTECompoundProps) => {
  const { content, checkmarks, shouldGrow, fullWidth } = props

  const updatedContent = addBaseDomain(content as string)
  return (
    <div
      className={classnames(
        'Content content-block',
        {
          checkmarks: checkmarks === 'true',
        },
        {
          ['u-flexGrow']: shouldGrow,
        },
        {
          ['u-sizeFull']: fullWidth,
        }
      )}
      dangerouslySetInnerHTML={{
        __html: DOMPurify.sanitize(updatedContent ?? ''),
      }}></div>
  )
}
